import { LanguageIcon } from '@heroicons/react/24/outline';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { navigate } from 'gatsby';
import Cookies from 'js-cookie';
import React, { type FC } from 'react';
import { Dropdown, Link } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '../../../../../hooks/pageContext';
import type { StrapiArticleType } from '../../../../../templates/post/types';
import { formatSlug } from '../../../../../utils/utils';
import type { NavbarButtonProps } from './types';

const NavbarButton: FC<NavbarButtonProps> = ({ link, index, supportedLanguages, postTranslatedSlugs }) => {
    const { t } = useTranslation();
    const { handleChangeLanguage } = usePageContext();

    const getLocaleLabel = (locale: string) => {
        const localeLabel = link.options.find((option) => option.locale === locale);
        return localeLabel?.value ?? locale;
    };

    const handleNavigatePost = (article: StrapiArticleType) => {
        const locale = article.locale.split('-')[0];
        const result = article.slug;

        const url = `/${formatSlug(result, locale)}`;
        navigate(url);
    };

    const handleClick = (value) => {
        const pathname = window.location.pathname;
        const result = pathname.split('/trade-pro/')[1];
        const url = `/${formatSlug(result, value.locale)}`;

        Cookies.set('language', value.locale);
        handleChangeLanguage(value.locale);
        // if the pathname doesn't include /trade-pro/ -> go to home page
        const shouldGoHome = !pathname.includes('/trade-pro/');
        if (!shouldGoHome) {
            if (pathname !== url) navigate(url);
        } else {
            navigate(value.link);
        }
    };

    if (link.type === 'dropdown-language' && supportedLanguages.length > 1) {
        return (
            <Dropdown className="dropdown-end" key={`navbar-button-${index}`}>
                <span className="cursor-pointer">
                    <LanguageIcon className="w-5 h-5 text-[#888]" />
                </span>
                <Dropdown.Menu className="w-52">
                    {postTranslatedSlugs &&
                        (postTranslatedSlugs.length > 0 ? (
                            postTranslatedSlugs.map((article, idx) => (
                                <Dropdown.Item key={`language-menu-item-${idx + 1}`} onClick={() => handleNavigatePost(article)}>
                                    <span className="text-gray-800 no-underline">{getLocaleLabel(article.locale)}</span>
                                </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item>
                                <span className="text-gray-800 no-underline">
                                    {t('common.emptyTranslations', 'This article is not translated yet')}
                                </span>
                            </Dropdown.Item>
                        ))}
                    {!postTranslatedSlugs &&
                        !!link.options.length &&
                        link.options.map((option, idx) => (
                            <Dropdown.Item key={`language-menu-item-${idx + 1}`} onClick={() => handleClick(option)}>
                                <span className="text-gray-800 no-underline">{option.value}</span>
                            </Dropdown.Item>
                        ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    return (
        <Link href={link.href} key={`navbar-button-${index + 1}`} className="border-0 outline-none cursor-pointer pl-4 ">
            {link.icon}
        </Link>
    );
};

export default NavbarButton;
